import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Geek at a music festival: Day 4",
  "description": "",
  "published": "2012-07-15T00:00:00.000Z",
  "redirect_from": ["/blog/geek-at-a-music-festival-day-4/swizec/4850"],
  "categories": "exit, festival, Food and Drink Related, Homeopathy, Jack Daniel, Liquor and Wine, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Always know how to get home on your own. Always.`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage2.instagram.com/1aabd8acce2611e19b0622000a1e8a4f_7.jpg",
        "alt": "@kalkulus enjoying my hat",
        "title": "@kalkulus enjoying my hat"
      }}></img></p>
    <p>{`Otherwise you might find yourself stuck on a stage full of bad music, milfs and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Homeopathy",
        "title": "Homeopathy"
      }}>{`homeopathic`}</a>{` jack cola. But the worst was really the homeopathic whiskey, look, guys, you have this cool truck branded all over with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Jack_Daniel%27s",
        "title": "Jack Daniel's"
      }}>{`Jack Daniel's`}</a>{`. I even have to trade my personal data to get in.`}</p>
    <p>{`Might as well serve some bourbon eh ... except you don't.`}</p>
    <p>{`Honestly, though, last night had the potential for being super awesome, I was just too tired to actually enjoy it. Zombied through the whole night - could compact all the interesting events into an hour.`}</p>
    <p>{`It started off incredibly well with the beatboxer on the main stage. The feats he could accomplish with his mouth were just brilliant. Then just as `}<a parentName="p" {...{
        "href": "http://www.hatebreed.com/",
        "title": "Hatebreed"
      }}>{`Hatebreed`}</a>{` made it look like the night was going to explode into awesome - great nostalgia for my headbanging days - the whole night just sort of fell apart.`}</p>
    <p>{`The guys met up with some milfy friends who wanted to go to the Jack Daniel's stage and when we got there the music simply wasn't enough to keep my blood pumping.`}</p>
    <p>{`And just like that, all the tired I had been keeping at bay gushed out in a waterfall of Being Dead (tm). Wanted to dance, but could barely lift my feet off the ground, let alone trying to raise my arms.`}</p>
    <p>{`My body just shut down. The watered down JD didn't help either.`}</p>
    <p>{`We eventually made it to the latino stage, which was a bit better with the high beats per minute and energy, but even that didn't last long. Just as I was starting to wake up and we got some good company - the Slovenian crew from the previous night - everybody suddenly left.`}</p>
    <p>{`But hey, I had my company, starting to have a good chat when suddenly `}<em parentName="p">{`"Fuck! I don't know how to get home without them!"`}</em>{` and I just took off like the wind ...`}</p>
    <p>{`... right into the beanbag chillout zone. Where I awkwardly stared at the sky while a set of A Guy and A Girl lay on each side of me feeling very entertained for some reason.`}</p>
    <p>{`Tonight's going to be awesome though, Guns'n'roses! Hopefully I won't have to talk tomorrow since this is the first gig where I actually know the lyrics and my voice is barely more than a croak as it is.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-21-e1342368872701-764x1024.jpg",
        "alt": "Girl on stilts!",
        "title": "Girl on stilts!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-41-e1342368973262-1024x764.jpg",
        "alt": "@tamejhna knows how to party",
        "title": "@tamejhna knows how to party"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-32-e1342369052888-764x1024.jpg",
        "alt": "Light thingies",
        "title": "Light thingies"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/zipline-e1342369138635-1024x764.jpg",
        "alt": "Zipline against the dawn",
        "title": "Zipline against the dawn"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo3-1024x764.jpg",
        "alt": "I have to clean my shoes every day",
        "title": "I have to clean my shoes every day"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100106846_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}>{`Geek at a music festival: Day 1`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-2/swizec/4830"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100305583_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-2/swizec/4830"
        }}>{`Geek at a music festival: Day 2`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-3/swizec/4838"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100568602_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-3/swizec/4838"
        }}>{`Geek at a music festival: Day 3`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=437bff9f-68d7-43ba-9e9f-88d47eb0a0a7",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      